import React from 'react';
import styles from '../belabeautybarretos/belabeautybarretos.module.scss';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const Belabeautybarretos: React.FC = () => {

    return (
        <div className={styles.belabeautybarretos}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <h1 className="pb-2">Bela Beauty</h1>
                    <p>SOBRANCELHA | CÍLIOS | UNHAS</p>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5517991386688?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="AGENDAMENTO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><WhatsappIcon height="40" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/GM9PwipzT9zqq5CR9"
                            title="LOCALIZAÇÃO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><MapsIcon height="40" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/belabeautybarretos?igsh=c3A3dWFzNnVteDI3"
                            title="INSTAGRAM"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "10px",
                                borderRadius: "100%",
                            }}><InstagramIcon height="32" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Belabeautybarretos;
